module.exports = __webpack_public_path__ + "static/media/generic-mobile.8d13f100.svg";